<template lang="pug">
  .history-tier
    .form-section
      .history-container
        .history-label(:class="color") Version
        div {{ dataOriginal.version }}
      .history-container
        .history-label(:class="color") {{ capitalize(dataOriginal.transaction) }}d by
        shNameUser(v-if="dataOriginal.transaction === 'create'" :dni="dataOriginal.createdBy")
        shNameUser(v-else :dni="dataOriginal.updatedBy")
      .history-container(v-if="dataOriginal.name")
        .history-label Tier Name
        div {{ dataOriginal.name }}
      .history-container(v-if="dataOriginal.warehouse")
        .history-label Warehouse
        div {{ dataOriginal.warehouse }}
      .history-container(v-if="dataOriginal.shelf")
        .history-label Shelf
        div {{ dataOriginal.shelf }}
</template>

<script>
import mFilters from '@/mixins/filters'
import shNameUser from '@/components/elements/NameUser'

export default {
  name: 'HistoryTier',

  mixins: [mFilters],

  components: { shNameUser },

  props: {
    dataOriginal: Object,
    color: String
  }
}
</script>

<style lang="stylus">
.history-tier
  position relative
  margin 1.4em 0 1.8em 0
</style>



// WEBPACK FOOTER //
// src/components/pages/tier/History.vue